import { render } from "./post-smtp-documentation.vue?vue&type=template&id=826bc4c8&scoped=true"
import script from "./post-smtp-documentation.vue?vue&type=script&lang=js"
export * from "./post-smtp-documentation.vue?vue&type=script&lang=js"

import "./post-smtp-documentation.vue?vue&type=style&index=0&id=826bc4c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-826bc4c8"]])

export default __exports__